import { render } from "./DemandCenterView.vue?vue&type=template&id=1ef6cdf6&scoped=true"
import script from "./DemandCenterView.vue?vue&type=script&lang=js"
export * from "./DemandCenterView.vue?vue&type=script&lang=js"

import "./DemandCenterView.vue?vue&type=style&index=0&id=1ef6cdf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef6cdf6"]])

export default __exports__